var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"nav-link dropdown-toggle",attrs:{"to":{name: 'EventChat', params: {eventSlug: _vm.eventSlug}}}},[_c('div',{staticClass:"help-icon icon-toggle"},[_c('i',{staticClass:"material-icons"},[_vm._v("forum")])]),_c('div',{staticClass:"label ml-2"},[_vm._v(_vm._s(_vm.$t('Chats')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }